// extracted by mini-css-extract-plugin
module.exports = {"root":"AiSummary-mobile-module__root___baGD6"};